// 3rd
import {Model} from '@vuex-orm/core';
// models
import ProductCategory from './ProductCategory';
import Rank from './Rank';
// utils
import {
    api,
    authHeaders,
    errorHandler,
} from '../utils/api';
import {
    API_ENDPOINT_FETCH_PRODUCTS,
    LOADER_FETCH_PRODUCTS,
    POINTS_FILTER,
} from '../utils/constants';

export default class Product extends Model {
    static entity = 'products';

    static fields() {
        return {
            id: this.attr(null),
            title: this.attr(null),
            details: this.attr(null),
            price: this.attr(null),
            product_brand: this.string('MISSING'),
            images: this.attr(null),
            sku: this.attr(null),
            categories: this.attr(null),
            rank: this.attr(null),
            highlighted: this.boolean(true),
            measurement_cargo: this.boolean(false),
            required_rank: this.belongsTo(Rank, 'rank'),
            product_categories: this.hasManyBy(ProductCategory, 'categories'),
            related_products: this.attr(null),
            active: this.boolean(true),
            unavailable: this.boolean(false),
            available_in_country: this.boolean(false),
            related: this.hasManyBy(Product, 'related_products'),
            is_new: this.boolean(false),
            type: this.string('physical'),
        };
    }

    // api calls
    static async fetch() {
        Product.store().dispatch('wait/start', LOADER_FETCH_PRODUCTS);

        const response = await api.get(API_ENDPOINT_FETCH_PRODUCTS, authHeaders()).catch(errorHandler);
        if (!response) return;

        const {data} = response;
        const {
            ranks,
            categories,
            products,
        } = data;

        Rank.insert({
            data: ranks,
        });
        ProductCategory.insert({
            data: categories,
        });
        Product.insert({
            data: products,
        });

        Product.store().dispatch('wait/end', LOADER_FETCH_PRODUCTS);
    }

    // getters
    static getAll() {
        return Product.query().where('active', true).withAll().all();
    }

    static getRandomHighlighted() {
        const products = Product.query()
            .where('highlighted', true)
            .where('active', true)
            .withAll().get();
        // the sort method is randomizing the array entries
        return products.sort(() => .5 - Math.random()).slice(0, 1);
    }

    static getRandomByCategory(productParent) {
        const products = Product.query()
            .where((product) => {
                return (
                    product.id !== productParent.id &&
                    productParent.categories.some((el) =>
                        product.categories.includes(el),
                    )
                );
            })
            .where('active', true)
            .withAll().get();
        // the sort method is randomizing the array entries
        return products.sort(() => .5 - Math.random()).slice(0, 4);
    }

    static getByCategory(category, categoryFilter, pointsFilter, rankFilter, newFilter) {
        return Product.query()
            .where('categories', (ids) => {
                if (categoryFilter) {
                    return ids.includes(categoryFilter);
                } else {
                    return ids.includes(category.id);
                }
            })
            .where('rank', (ids) => {
                if (rankFilter.length <= 0) {
                    return ids;
                } else {
                    return rankFilter.includes(ids);
                }
            })
            .where('price', (price) => {
                if (POINTS_FILTER[pointsFilter]) {
                    const points = POINTS_FILTER[pointsFilter];
                    return price >= points.min && price <= points.max;
                } else {
                    return true;
                }
            })
            .where('is_new', (isNew) => {
                return (newFilter.length > 0 && newFilter.includes('new') && isNew === true || newFilter.length <= 0);
            })
            .orderBy('is_new', 'desc')
            .withAll().get();
    }

    static getFiltered(categoryFilter, pointsFilter, rankFilter, newFilter) {
        return Product.query()
            .where('active', true)
            .where('categories', (ids) => {
                if (categoryFilter) {
                    return ids.includes(categoryFilter);
                } else {
                    return true;
                }
            })
            .where('rank', (ids) => {
                if (rankFilter.length <= 0) {
                    return ids;
                } else {
                    return rankFilter.includes(ids);
                }
            })
            .where('price', (price) => {
                if (POINTS_FILTER[pointsFilter]) {
                    const points = POINTS_FILTER[pointsFilter];
                    return price >= points.min && price <= points.max;
                } else {
                    return true;
                }
            })
            .where('is_new', (isNew) => {
                return (newFilter.length > 0 && newFilter.includes('new') && isNew === true || newFilter.length <= 0);
            })
            .orderBy('is_new', 'desc')
            .withAll().get();
    }
}
